import { Helpers } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';
import { FiltersCreateHelper } from '../../helpers/filtersCreateHelper';
import {
  PROPERTY_HOME_STYLES, UNIT_TYPES,
} from '../constants/BuildingTypes';

const { ObjectHelper } = Helpers;

export default class PropertyStyleMapper {
  static mapFilterToRequestQuery(style) {
    return ObjectHelper.removeEmptyProperties({
      [QueryParams.Style]: FiltersCreateHelper.getFilterValues(PROPERTY_HOME_STYLES, style),
      [QueryParams.UnitType]: FiltersCreateHelper.getFilterValues(UNIT_TYPES, style),
    });
  }
}
